<template>
  <v-radio-group dense hide-details row :value="content" v-on:change="callChange" class="mt-0">
    <template v-slot:label>
      <div class="radiogroup-font">Setup the type of update: </div>
    </template>
    <v-radio key='0' label="relative update" :value=true style="margin-left: 6px;"></v-radio>
    <v-radio key='1' label="exact amount" :value=false></v-radio>
  </v-radio-group>     
</template>
    
<script>
  export default {
    
    props: {
      field: String,
      value: Boolean,
    },
    data() {
      return {
        content: this.value
      }
    }, 
    methods:{
      callChange(data){
          this.$emit('updateData', {"field": this.field, "value": data});
      },    
    }
  }
</script>
  
<style scoped>    
  .radiogroup-font{
      font-size: 17px !important; 
  }
</style>